import Helper from '@ember/component/helper';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

export default Helper.extend({
  taskService: service(),

  compute([userId] /*namedArgs*/) {
    return htmlSafe(get(this.taskService.usersById, `${userId}.displayName`));
  },
});
